'use strict';

import {RedocComponent, BaseComponent} from '../base';

@RedocComponent({
  selector: 'api-logo',
  styles: [`
    img{max-height:150px;width:auto;display:inline-block;max-width:100%;box-sizing:border-box}
  `],
  template: `
    <img *ngIf="data.imgUrl" [attr.src]="data.imgUrl" [ngStyle]="{'background-color': data.bgColor}">
  `
})
export class ApiLogo extends BaseComponent {
  constructor(schemaMgr) {
    super(schemaMgr);
  }

  prepareModel() {
    this.data = {};
    let logoInfo = this.componentSchema.info['x-logo'];
    if (!logoInfo) return;
    this.data.imgUrl = logoInfo.url;
    this.data.bgColor = logoInfo.backgroundColor || 'transparent';
  }
}
